module.exports = __webpack_public_path__ + "static/media/rut_correo.8fd437fd.svg";